module.exports = __webpack_public_path__ + "img/0703-封面内页的副本-01.c4be7a45.png";